import { render } from "./Item5.vue?vue&type=template&id=5f7f2fee&ts=true"
import script from "./Item5.vue?vue&type=script&lang=ts"
export * from "./Item5.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__